import BseDataStore from '../../datastores/BseDataStore';

const response: any[] = [];

export default class BseDataStoreMock implements BseDataStore {
  processBse() {
    throw new Error('Method not implemented.');
  }

  async getFormBse() {
    return {
      data: response
    };
  }

  registerBse() {
    // UT: boolean // fields: any, // origin: string, // operationNumber: number,
    return { status: 'OK', operationNumber: '123' };
  }

  activatePayOrder() {
    throw new Error('Method not implemented.');
  }

  // FALTA IMPLEMENTAR MOCK
  getStateBse() {
    return {
      id: '1',
      type: '1',
      name: '1',
      online: '1',
      benefit: '1',
      duration: '1',
      startDateConfigurate: '1',
      endDateConfigurate: '1',
      hasRestrictions: '1',
      amount: '1',
      dateRequest: '1',
      dateFinalized: '1',
      isPaid: '1',
      hasPaymentOrder: '1',
      isOutOfDate: '1',
      hasPendingOrFinalizedProcedures: '1',
      operationNumber: '1',
      commentary: '1',
      isSaved: '1',
      discount: '1'
    };
  }

  getBseDocument() {
    return {};
  }

  uploadBseDocument() {
    return {
      data: {
        statusDesc: 'Archivo Cargado con exito',
        idFile: 1034,
        linkDrop:
          'https://uc7ce91cc45328e343327766113d.dl.dropboxusercontent.com/cd/0/get/B2EkanDeFHl85xU2K5oZMqrPeAtr_LbhaVF6SX1lsWxgoG-vYrkAa_2i8NrYQsnf9b0hsVoz_5CbkDpGdgwMZtYYm1oOwqx47esdnBSh9WE8pur0db2lR2pbywqwQvUWuXIkwSZ123CkvGxlbuOXKF9JBvGaN7Kh-091nHWEH5ImodFt4e_CCSKIkovjb-XXKmY/file'
      }
    };
  }

  async deleteFileBse() {
    return {
      data: response
    };
  }
}
